import { Component, OnInit, ViewChild, Inject, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogRef, MatPaginator, MAT_DIALOG_DATA } from '@angular/material';
import { HttpService } from '../http.service';
import { SpotOnDriverComponent } from '../spot-on-driver/spot-on-driver.component';
import { SnackbarService } from '../snackbar.service';
import { Messages } from '../constants/messages';
import { TranslateService } from '@ngx-translate/core';
import { AddOwnFleetDriverComponent } from '../add-own-fleet-driver/add-own-fleet-driver.component';
import { AddVehicleComponent } from '../vehicles/add-vehicle/add-vehicle.component';
import { AddDriverComponent } from '../drivers/add-driver/add-driver.component';
import { AddSpotDriverComponent } from '../add-spot-driver/add-spot-driver.component';
import { AddSpotVehicleComponent } from '../add-spot-vehicle/add-spot-vehicle.component';
enum status_string {
  online = 'Online',
  offline = 'Offline',
}

declare var google: any;

@Component({
  selector: 'app-re-assign',
  templateUrl: './re-assign.component.html',
  styleUrls: ['./re-assign.component.scss']
})
export class ReAssignComponent implements OnInit {

  map;
  mapMarkers: any = [];
  truckIcon = {
    url: 'assets/truck-icon.svg',
    scaledSize: new google.maps.Size(30, 30)
  };
  showLoader = false;
  picon = {
    url: 'assets/Pickup.svg', // url
    scaledSize: new google.maps.Size(30, 30)
  };
  assignFilter: any = {};
  assignArr = [];
  totalAssigned = 0;
  columnHeaders: string[] = ['select', 'vehicle', 'driverName', 'distance'];
  vehicle: any;
  pickup;
  deliveries: any = [];
  bounds; dialogRef;
  inServiceVehicleNo = '';
  re_assign_type: any;
  mobile_number;
  vehicle_number;
  searchMobileNo = '';
  searchVehicleNo = '';
  vehicle_by_capacity = false;
  vehicle_less_by_capacity = false;
  loadImg = 'assets/Own-Driver.svg';
  viewMapFlag:any = false;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('warning', { static: true }) warning: TemplateRef<any>;
  messages = new Messages();
  constructor(private dialog: MatDialog, private translation: TranslateService, private openDialog: MatDialogRef<ReAssignComponent>, private http: HttpService, @Inject(MAT_DIALOG_DATA) public parentData: any, private snackBar: SnackbarService) { }

  ngOnInit() {
    this.pickup = this.parentData.pickup.location;
    this.deliveries = this.parentData.deliveries;
    this.vehicle = this.parentData.vehicle_type;
    this.re_assign_type = this.parentData.re_assign_type;
    this.vehicle_by_capacity = false;
    this.vehicle_less_by_capacity = false;
    if (this.re_assign_type == 'vehicle') {
      this.columnHeaders = ['select', 'vehicle', 'distance'];
      this.getAllVehicleDetails();
      this.loadImg = 'assets/spotdriver.svg';
    } else if (this.re_assign_type == 'driver') {
      this.columnHeaders = ['select', 'driverName', 'distance'];
      this.getDriverDetails();
      this.loadImg = 'assets/Own-Driver.svg';
    } else {
      this.getVehicleDetails();
      this.loadImg = 'assets/Own-Driver.svg';
    }
  }

  viewMap() {
    this.viewMapFlag =true;
    setTimeout(() => {
      this.initMap()
    }, 100);
  }

  getDriverDetails(filter: any = {}) {

    filter.limit = this.paginator.pageSize || 5;
    filter.skip = this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);
    if (this.searchMobileNo) {
      filter.mobile = this.searchMobileNo;
    }

    this.http.get('driver/get_drivers', filter, 3).subscribe(
      (data: any) => {

        this.assignArr = [];
        this.assignArr.length = 0;
        this.totalAssigned = data.data.data.count;// data.data.length;
        const result = data.data.data.drivers;
        result.forEach(element => {
          this.assignArr.push({
            select: false,
            driverName: element.name,
            driver_id: element._id,
            mobile: element.mobile,
            distance: element.distance ? (element.distance / 1000).toFixed(0) : 'N/A',
            ws_opt_in: element.ws_opt_in,
            status: element.status,
            status_string: element.status ? status_string[element.status] : 'N/A',
            current_location: element.home_location || {},
          });
        });
        this.paginator._intl.itemsPerPageLabel = this.translation.instant('DRIVERS.pagination_label');
        this.bounds = new google.maps.LatLngBounds();
        this.placeFirstPickup(this.pickup, 'P1', this.picon)
        this.plotDrivers(this.assignArr);
      }
    );

  }
  getAllVehicleDetails(filter: any = {}) {

    filter.limit = this.paginator.pageSize || 5;
    filter.skip = this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);
    if (this.searchVehicleNo) {
      filter.vehicle_no = this.searchVehicleNo;
    }
    if(this.vehicle_by_capacity) {
      filter.vehicle_by_capacity = this.vehicle_by_capacity
    } else if(this.vehicle_less_by_capacity) {
      filter.vehicle_less_by_capacity = this.vehicle_less_by_capacity
      filter.shipment = this.parentData.shipment_id
    }
    this.http.get('vehicle/get_vehicles?vehicle_type=' + this.vehicle._id, filter, 3).subscribe(
      (data: any) => {

        this.assignArr = [];
        this.assignArr.length = 0;
        this.totalAssigned = data.data.data.count;// data.data.length;
        const result = data.data.data.vehicles;
        result.forEach(element => {
          this.assignArr.push({
            select: false,
            vehicle_id: element._id,
            vehicle: element.REG_number,
            vehicle_type: this.vehicle,
            distance: element.distance ? (element.distance / 1000).toFixed(0) : 'N/A',
            current_location: element.current_location || {},
            // assigned_shipment: element.assigned_shipment ? element.assigned_shipment : ''
          });
        });
        this.bounds = new google.maps.LatLngBounds();
        this.placeFirstPickup(this.pickup, 'P1', this.picon)
        this.plotDrivers(this.assignArr);
        this.paginator._intl.itemsPerPageLabel = this.translation.instant('DRIVERS.pagination_label1');
      }
    );

  }


  getVehicleDetails(filter: any = {}) {
    filter.is_free = false;
    filter.limit = this.paginator.pageSize || 5;
    filter.skip = this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);
    if (this.vehicle_by_capacity && this.parentData.vehicle_type && this.parentData.vehicle_type._id) {
      filter.vehicle_type = this.parentData.vehicle_type._id;
    }
    if (this.searchMobileNo) {
      filter.mobile = this.searchMobileNo;
    }
    if (this.searchVehicleNo) {
      filter.vehicle_no = this.searchVehicleNo;
    }
    filter.vehicle_by_capacity = this.vehicle_by_capacity;
    this.http.get('driver/get_all_attached?shipment=' + this.parentData.shipment_id, filter).subscribe(
      (data: any) => {
        this.assignArr = [];
        this.assignArr.length = 0;
        this.totalAssigned = data.data.count;// data.data.length;
        const result = data.data.drivers;
        result.forEach(element => {
          this.assignArr.push({
            select: false,
            driverName: element.name,
            driver_id: element._id,
            vehicle: element.vehicle_no,
            vehicle_type: element.vehicle_type,
            mobile: element.mobile,
            unitname: element.carrier_unit ? element.carrier_unit.name : '',
            distance: element.distance ? (element.distance / 1000).toFixed(0) : 'N/A',
            is_temporary: (element.driver_type && element.driver_type == 'temporary'),
            in_service: (element.vehicle) ? element.vehicle.maintenance ? element.vehicle.maintenance.in_service ? true : false : false : false,

            // PENDING::provision to be changed for different metrics as well
            status: element.status,
            status_string: element.status ? status_string[element.status] : 'N/A',
            current_location: {
              latitude: element.geo_point.coordinates[1] || 0,
              longitude: element.geo_point.coordinates[0] || 0,
            },
            assigned_shipment: element.assigned_shipment ? element.assigned_shipment : ''
          });
        });
        this.paginator._intl.itemsPerPageLabel = this.translation.instant('DRIVERS.pagination_label');

        // (this.mapMarkers.length) ? this.removeMarkers(this.mapMarkers) : '';
        this.bounds = new google.maps.LatLngBounds();
        this.placeFirstPickup(this.pickup, 'P1', this.picon)
        this.plotDrivers(this.assignArr);
      }
    );

  }

  closeAssignModal(data = false) {

    this.removeMarkers(this.mapMarkers);
    this.openDialog.close(data);
  }
  openSpotDriver() {

    if (this.re_assign_type == 'driver') {
      const data: any = {
        shipment_id: this.parentData.shipment_id
      };
      const dialogRef = this.dialog.open(AddSpotDriverComponent, {
        data
      });
      dialogRef.afterClosed().subscribe(
        (data: any) => {
          if (data && data.statusCode === 200) {
            // this.getDriverDetails();
            this.openDialog.close(true);
          }
        }
      );
    } else if (this.re_assign_type == 'vehicle') {
      const data: any = {
        shipment_id: this.parentData.shipment_id,
        driver_id: this.parentData.driver_id,
        vehicle: this.vehicle
      };

      const dialogRef = this.dialog.open(AddSpotVehicleComponent, {
        data
      });
      dialogRef.afterClosed().subscribe(
        (data: any) => {
          if (data && data.statusCode === 200) {
            // this.getAllVehicleDetails();
            this.openDialog.close(true);
          }
        }
      );
    } else {

      const data: any = {
        vehicle: this.vehicle
      };
      const dialogRef = this.dialog.open(SpotOnDriverComponent, {
        data
      });
      dialogRef.afterClosed().subscribe(
        (data: any) => {
          if (data && data.statusCode === 200) {
            this.getVehicleDetails();
          }
        }
      );

    }




  }
  openOwnFleetDriver() {
    const data: any = {
      vehicle: this.vehicle
    };
    const dialogRef = this.dialog.open(AddOwnFleetDriverComponent,
      {
        data
      });
    dialogRef.afterClosed().subscribe(
      (data: any) => {
        if (data && data.statusCode === 200) {
          this.getVehicleDetails();
        }
      }
    );
  }
  openReAssignType(heading = 'ADD', driver: any = '') {
    const data: any = {
      header: 'Add'
    };

    if (this.re_assign_type == 'driver') {
      const dialogRef = this.dialog.open(AddDriverComponent, {
        data
      });
      dialogRef.afterClosed().subscribe(
        (data: any) => {

          if (data && data.statusCode === 200) {
            this.getDriverDetails();


          }
        }
      );
    } else if (this.re_assign_type == 'vehicle') {

      const data: any = {
        vehicle: this.vehicle
      };

      const dialogRef = this.dialog.open(AddVehicleComponent, {
        data
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result.statusCode == 200) {
          this.getAllVehicleDetails();

        }
      });
    }


  }
  pageNavigate(event) {

    this.assignFilter.limit = event.pageSize;
    this.assignFilter.skip = event.pageIndex * event.pageSize;
    //this.getVehicleDetails(this.assignFilter);
    if (this.re_assign_type == 'vehicle') {
      this.columnHeaders = ['select', 'vehicle', 'distance'];
      this.getAllVehicleDetails();
    } else if (this.re_assign_type == 'driver') {
      this.columnHeaders = ['select', 'driverName', 'distance'];
      this.getDriverDetails();
    } else {
      this.getVehicleDetails();
    }
  }

  initMap(lat = 0, lng = 0) {
    const mapProp = {
      center: new google.maps.LatLng(lat, lng),
      zoom: 12,
      mapTypeControl: true,
      scaleControl: false,
      streetViewControl: false,
      zoomControl: true,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
      }
    };
    this.map = new google.maps.Map(document.getElementById('reAssignPathMap'), mapProp);
    google.maps.event.addListener(this.map, 'click', function (event) {
    });
    if(this.assignArr.length) {
      this.placeFirstPickup(this.pickup, 'P1', this.picon)
        this.plotDrivers(this.assignArr); } else {
        this.map.setZoom(11);
      }


  }

  applyFilter(filterValue: string, type: string) {

    if (type == 'mobile') {
      this.searchMobileNo = filterValue;
      if (filterValue.length == 0 || filterValue.length > 8) {
        if (this.re_assign_type == 'driver') {
          this.getDriverDetails();
        } else if (this.re_assign_type == 'vehicle') {
          this.getAllVehicleDetails();
        } else {
          this.getVehicleDetails();
        }

      }

    } else if (type == 'vehicleno') {
      this.searchVehicleNo = filterValue;
      if (filterValue.length == 0 || filterValue.length > 3) {
        if (this.re_assign_type == 'driver') {
          this.getDriverDetails();
        } else if (this.re_assign_type == 'vehicle') {
          this.getAllVehicleDetails();
        } else {
          this.getVehicleDetails();
        }
      }
    }

  }

  plotDrivers(drivers) {
    if (drivers.length) {
      drivers.forEach(element => {
        if (element.current_location.latitude && element.current_location.longitude) {
          const latLng = { lat: parseFloat(element.current_location.latitude), lng: parseFloat(element.current_location.longitude) };
          this.placeMarker(element.current_location, '', this.truckIcon, element.vehicle);
          this.bounds.extend(latLng);
          if(this.map) {
          this.map.fitBounds(this.bounds);
          }
        }
      });
    } else {
      if(this.map) {
      this.map.setZoom(11);
      }
    }

  }

  placeMarker(location, label = '', icon: any = '',title: any = '') {
    if(this.map) {
    const markerOpt: any = {
      position: { lat: parseFloat(location.latitude), lng: parseFloat(location.longitude) },
      map: this.map,
      label: label || '',
      title: title || ''
    };
    (icon) ? markerOpt.icon = icon : '';

    const marker = new google.maps.Marker(markerOpt);
    this.mapMarkers.push(marker);
    marker.setMap(this.map);
    }
  }
  placeFirstPickup({geo_point}, label = '', icon: any = '') {
    // const bounds = new google.maps.LatLngBounds();
    const markerOpt: any = {
      position: { lat: parseFloat(geo_point.coordinates[1]), lng: parseFloat(geo_point.coordinates[0]) },
      map: this.map,
      label: {
        text: label,
        color: "#fff",
      }
    };
    (icon) ? markerOpt.icon = icon : '';

    const latLng = {
      lat: geo_point.coordinates[1],
      lng:geo_point.coordinates[0]
    };

    const marker = new google.maps.Marker(markerOpt);
    this.mapMarkers.push(marker);
    marker.setMap(this.map);
    this.bounds.extend(latLng);
    this.map.fitBounds(this.bounds);
  }

  removeMarkers(markers) {
    markers.forEach(element => element.setMap(null));
    this.map.setZoom(12);
  }

  selectRow($event: any, row: Element, index) {
    this.assignArr.forEach(function (row, i) {
      if (index == i)
        row.select = true;
      else {
        row.select = false;
      }
    });

  }

  assign() {
    if (this.re_assign_type == 'driver') {
      const drivers = this.assignArr.filter(item => item.select);
      if (drivers.length > 0) {
        const reAssign: any = {
          shipment_id: this.parentData.shipment_id,
          attached_driver_id: drivers[0].driver_id,
          // driver_mobile: drivers[0].mobile,
          driver_name: drivers[0].driverName,
          ws_opt_in: drivers[0].ws_opt_in
        };
        let allocate = true;
        this.allocateDriver(allocate, reAssign);
      } else {
        this.snackBar.openSnackBar(this.messages.reAssign.oneDriver, '', 'err');

      }
    }
    else if (this.re_assign_type == 'vehicle') {
      const vehicle = this.assignArr.filter(item => item.select);
      if (vehicle.length > 0) {
        const reAssign: any = {
          shipment_id: this.parentData.shipment_id,
          driver_id: this.parentData.driver_id,
          vehicle_id: vehicle[0].vehicle_id,
          // vehicle_no: vehicle[0].vehicle,

        };
        let allocate = true;
        this.allocateVehicle(allocate, reAssign);
      } else {
        this.snackBar.openSnackBar(this.messages.reAssign.oneVehicle, '', 'err');
        // return;
      }
    } else {
      const drivers = this.assignArr.filter(item => item.select).map(item => item.driver_id);
      const inServiceVehicles = this.assignArr.filter(item => (item.select && item.in_service));
      if (drivers.length == 0) {
        this.snackBar.openSnackBar(this.messages.reAssign.selectDriver, '', 'err');
        return;
      }
      if (drivers.length >= 2) {
        this.snackBar.openSnackBar(this.messages.reAssign.oneDriver, '', 'err');
        return;
      }
      const reAssign: any = {
        shipment_id: this.parentData.shipment_id,
        driver_id: drivers[0]
      };
      let allocate = true;
      if (inServiceVehicles.length) {
        allocate = false;
        this.inServiceVehicleNo = inServiceVehicles[0].vehicle;
        this.dialogRef = this.dialog.open(this.warning);
        this.dialogRef.afterClosed().subscribe(
          (data: any) => {
            allocate = data;
            this.allocate(allocate, reAssign);
          }
        );
      } else {
        this.allocate(allocate, reAssign);
      }
    }

  }
  allocate(data, reAssign) {
    if (data) {
      this.showLoader = true;
      this.http.post('shipment/re_assign', reAssign).subscribe(
        (data: any) => {
          this.showLoader = false;

          if (data.statusCode === 200) {

            if (this.parentData.header == 'Assign Driver') {
              this.snackBar.openSnackBar(this.translation.instant('MESSAGE.REASSIGN.both'), '');
            } else {
              this.snackBar.openSnackBar(this.translation.instant('MESSAGE.REASSIGN.both'), '');
            }
            this.openDialog.close(true);
          }
        },
        (err: any) => {
          this.showLoader = false;
          this.snackBar.openSnackBar(err.error.message, '', 'err');
        }
      );
    } else this.showLoader = false;
  }

  allocateDriver(data, reAssign) {

    if (data) {
      this.showLoader = true;

      this.http.post('shipment/re_assign_driver', reAssign).subscribe(
        (data: any) => {

          this.showLoader = false;

          if (data.statusCode === 200) {
            if (this.parentData.header == 'Assign Driver') {
              this.snackBar.openSnackBar(this.translation.instant('MESSAGE.REASSIGN.assignSuccess'), '');
            } else {
              this.snackBar.openSnackBar(this.translation.instant('MESSAGE.REASSIGN.success'), '');
            }
            this.openDialog.close(true);
          }
        },
        (err: any) => {
          this.showLoader = false;
          this.snackBar.openSnackBar(err.error.message, '', 'err');
        }
      );
    } else this.showLoader = false;
  }
  allocateVehicle(data, reAssign) {

    if (data) {
      this.showLoader = true;
      this.http.post('shipment/re_assign_vehicle', reAssign).subscribe(
        (data: any) => {

          this.showLoader = false;

          if (data.statusCode === 200) {
            if (this.parentData.header == 'Assign Driver') {
              this.snackBar.openSnackBar(this.translation.instant('MESSAGE.REASSIGN.vehicleassignSuccess'), '');
            } else {
              this.snackBar.openSnackBar(this.translation.instant('MESSAGE.REASSIGN.vehiclesuccess'), '');
            }
            this.openDialog.close(true);
          }
        },
        (err: any) => {
          this.showLoader = false;
          this.snackBar.openSnackBar(err.error.message, '', 'err');
        }
      );
    } else this.showLoader = false;
  }
  clearMobileNumber() {
    this.mobile_number = '';
    this.applyFilter('', 'mobile');
  }
  clearVehicleNumber() {
    this.vehicle_number = '';
    this.applyFilter('', 'vehicleno')
  }
  vehicleCapacity(){
    this.vehicle_by_capacity = true;
    this.vehicle_less_by_capacity = false;
    if (this.re_assign_type == 'vehicle') {
      this.getAllVehicleDetails();
    }else{
      this.getVehicleDetails();
    }
  }
  vehicleLessCapacity(){
    this.vehicle_by_capacity = false;
    this.vehicle_less_by_capacity = true;
    if (this.re_assign_type == 'vehicle') {
      this.getAllVehicleDetails();
    }else{
      this.getVehicleDetails();
    }
  }
}
